import { defaultTo } from 'lodash';
import { IModel, Model, ModelRecord, BrandModel } from '@common/models';

export interface ISalesItemPriceRuleBrandModel extends IModel {
  salesItemPriceRuleBrandId: number;
  salesItemPriceRuleId: number;
  brandId: number;
  brand: BrandModel;
}

export class SalesItemPriceRuleBrandModel
  extends Model
  implements ModelRecord<ISalesItemPriceRuleBrandModel>
{
  salesItemPriceRuleBrandId: number;
  salesItemPriceRuleId: number;
  brandId: number;
  brand: BrandModel;

  constructor(params?: Partial<ISalesItemPriceRuleBrandModel>) {
    super(params);
    this.salesItemPriceRuleBrandId = defaultTo(
      params?.salesItemPriceRuleBrandId,
      0,
    );
    this.salesItemPriceRuleId = defaultTo(params?.salesItemPriceRuleId, 0);
    this.brandId = defaultTo(params?.brandId, 0);
    this.brand = params?.brand
      ? new BrandModel(params.brand)
      : new BrandModel();
  }
}
